module.exports = __webpack_public_path__ + "img/150.567cc0ac.jpg";